import React from 'react';
import styled from 'styled-components';

import Wrapper from './Wrapper';
import SubmitForm from './SubmitForm';
import AnnualSavingControl from './AnnualSavingControl';
import Results from './../Results';
import { INDUSTRIES } from './../../constants';
import { RangerInput, Form, DropdownInput, TextInput } from './../../controls';

const CalculatorWrapper = styled.div`
	border: 1px solid #0798ff;
	border-radius: 1em;
	padding: 2em;
	@media(max-width: 670px) {
		padding: 1em;
  }
  p { line-height: 1em; }
`;

const SubmitFormWrapper = styled.div`
	background: #f1f8ff;
	border-radius: 1em;
	margin-top: 20px;
	padding: 20px;
`;

const resultTitle = 'Results - The potential direct costs to your business';

const resultSchema = {
	averageCostPerDay: {
		name: 'averageCostPerDay',
		label: 'Average cost of absenteeism per employee per day',
		info: 'The average cost of absenteeism per employee per day is calculated by dividing the average salary by the number of working days (233)',
		type: 'currency'
	},
	averageCostPerYear: {
		name: 'averageCostPerYear',
		label: 'Average cost of absenteeism per employee per year',
		info: 'The average cost of absenteeism per employee per year is calculated by dividing the average salary by the number of working days (233) multiplied by the average number of days absent per employee per year',
		type: 'currency'
	},
	totalCostPerDay: {
		name: 'totalCostPerDay',
		label: 'Total cost of absenteeism to the business per year',
		info: 'The total cost of absenteeism is the average cost of absenteeism per employee per year multiplied by the number of employees',
		type: 'currency'
	},
	annualSaving: {
		name: 'totalCostPerDay',
		label: 'Annual saving',
		info: 'Your annual saving is calculated by taking the total cost of absenteeism to the business per year multiplied by the percentage shown on the slider.',
		type: 'currency',
		renderer: AnnualSavingControl
	}
};

export const Calculator = ({ isDisabled, isLoading, errorMessages, onLoad, onSubmit, data = {}, results = {}, onChange, isNoPrivacy }) => {
	const handleOnChange = (value, fieldName) => onChange({ ...data, [fieldName]: value });
	return (
		<Wrapper>
			<CalculatorWrapper>
				<Form.Wrapper>
					<Form.Row>
						<Form.Label>Industry</Form.Label>
						<Form.LabelDescription><p>Select which industry sector you work in</p></Form.LabelDescription>
						<DropdownInput
							value={data.industry}
							options={INDUSTRIES}
							width='100%'
							onChange={value => (handleOnChange(value, 'industry'))}
						/>
					</Form.Row>
					<Form.Row>
						<Form.Label>Employees</Form.Label>
						<Form.LabelDescription><p>Number of employees</p></Form.LabelDescription>
						<TextInput
							min={1}
							max={100}
							value={data.numberOfEmployees}
							onChange={value => (handleOnChange(value, 'numberOfEmployees'))}
						/>
					</Form.Row>
					<Form.Row>
						<Form.LabelDescription>
							<p>Average employee salary</p>
							<span><i>If unknown, the UK average salary is £29,588<sup>1</sup></i></span>
						</Form.LabelDescription>
						<TextInput
							min={15000}
							max={50000}
							preffix='£'
							value={data.averageSalary}
							onChange={value => (handleOnChange(value, 'averageSalary'))}
						/>
					</Form.Row>
					<Form.Row>
						<Form.Label>Absenteeism</Form.Label>
						<Form.LabelDescription>
							<p>Average number of working days lost due to absenteeism per employee per year</p>
							<span><i>If unknown, in the UK employees average 5.9 days absent each year<sup>2</sup></i></span>
						</Form.LabelDescription>
						<RangerInput
							min={1}
							max={20}
							type='float'
							defaultValue={5.9}
							value={data.averageOfWorkingDay}
							onChange={value => (handleOnChange(value, 'averageOfWorkingDay'))}
						/>
					</Form.Row>
					<Results {...{ data, title: resultTitle, results, schema: resultSchema, onChange }} />
				</Form.Wrapper>
			</CalculatorWrapper>
			<SubmitFormWrapper>
				<SubmitForm {...{ data, isLoading, errorMessages, onLoad, onSubmit, isDisabled, onChange, isNoPrivacy }} />
			</SubmitFormWrapper>
			{/*<pre>*/}
				{/*{JSON.stringify(data)}*/}
			{/*</pre>*/}
			{/*<pre>*/}
				{/*{JSON.stringify(results)}*/}
			{/*</pre>*/}
		</Wrapper>
	);
};

export default Calculator;



// WEBPACK FOOTER //
// ./src/html/components/Calculator/Calculator.js